/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { keyframes, css as unboundedCSS } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

const slideFadeIn = keyframes({
	from: { opacity: 0, transform: 'translateY(1rem)' },
	to: { opacity: 1, transform: 'translateY(0)' },
});

const loadingStyles = unboundedCSS({
	flexDirection: 'column',
	position: 'fixed',
	bottom: token('space.200'),
	marginLeft: token('space.negative.200'),
	marginRight: token('space.negative.200'),
	marginTop: token('space.200'),
	zIndex: 400,
	width: 'calc(var(--ak-editor--line-length, 100%) + 32px)',
	animationName: slideFadeIn,
	animationDuration: '0.2s',
	animationTimingFunction: 'ease-out',
	animationFillMode: 'forwards',
	'@media (prefers-reduced-motion)': { animation: 'none' },
});

export const Container = React.forwardRef<HTMLDivElement, { children: React.ReactNode }>(
	({ children }, ref) => {
		return (
			<div css={loadingStyles} ref={ref}>
				{children}
			</div>
		);
	},
);
